"use strict";

var vm = new Vue({
  el: "#app",
  delimiters: ["%%", "%%"],
  data: function data() {
    return {
      cats: 1,
      country: "",
      ingredients: false,
      loaded: false,
      missingToy: false,
      modal: "",
      oldbundle: false,
      orderType: "multi",
      package: "bundle",
      ppImgTest: false,
      popup: false,
      step: 1,
      test: false,
      toy: null,
      upsell: true,
      upsell_taken: true,
      view: "original",
      weeks: 4,
      debug: false
    };
  },
  beforeMount: function beforeMount() {
    var self = this;
    function getParameterByName(name) {
      var url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    var step = getParameterByName("step");
    if (step !== null && step !== undefined) {
      self.step = step;
    }
    var type = "single";
    if (getParameterByName("ot") == "blk") {
      self.orderType = "multi";
    }
    //debug
    var debug = getParameterByName("debug");
    if (debug !== null && debug !== undefined) {
      self.debug = true;
    }
  },
  mounted: function mounted() {
    var self = this;
    function getParameterByName(name) {
      var url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    //check for # of cats in URL
    var cats = getParameterByName("cats");
    if (cats !== null && cats !== undefined) {
      console.log("Found " + cats + " cats in URL!");
      var cat_number = Number(cats);
      if (cat_number == 1) {
        this.cats = 1;
        this.step = 2;
      }
      if (cat_number == 2) {
        this.cats = 2;
        this.step = 2;
      }
      if (cat_number == 3 || cat_number == 4) {
        this.cats = 3;
        this.step = 2;
      }
    } else {
      window.location.hash = self.step;
    }
    //check for possible promotion in URL
    var promotion = getParameterByName("utm_campaign");
    if (promotion !== undefined && promotion !== null) {
      if (promotion.toLowerCase() == "laborday") {
        this.promotion = "laborday";
      }
    }
    //check for forceView in URL
    var forceView = getParameterByName("forceView");
    if (forceView !== null && forceView !== undefined) {
      this.view = forceView;
    }
    //geotracking stuff
    var getCookie = function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    };
    var country = getCookie("_plgeo");
    if (country !== undefined && country !== null) {
      // console.log("SETTING COUNTRY!", country);
      this.country = country;
    } else {
      setTimeout(function () {
        // console.log("TIMEOUT GET COOKIE");
        country = getCookie("_plgeo");
        if (country !== undefined && country !== null) {
          // console.log("TIMEOUT RESULT: ", country);
          self.country = country;
        }
      }, 4500);
    }
    self.loaded = true;
  },

  computed: {
    litterSummary: function litterSummary() {
      var summary = "";
      if (this.orderType == "multi") {
        summary = this.cats * 3 + " x PrettyLitter Cat Litter every 12 weeks @ $" + this.productOptions[1].price;
      } else {
        summary = this.cats + " x PrettyLitter Cat Litter every 4 weeks @ $" + this.productOptions[0].price;
      }
      return summary;
    },
    foodSummary: function foodSummary() {
      var summary = null;
      if (this.package == "bundle") {
        summary = "1 x PrettyPlease Cat Food every 4 weeks @ $25";
      }
      return summary;
    },
    totalPrice: function totalPrice() {
      var price = 0;

      if (this.orderType == "multi") {
        price = this.productOptions[1].price;
      } else {
        price = this.productOptions[0].price;
      }

      if (this.package == "bundle") {
        price += 15;
      }

      return price;
    },
    productOptions: function productOptions() {
      var arr = [];
      if (this.cats == 1) {
        var single = {
          vid: 9105042604068,
          image: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/tv_single_1cat.jpg?123",
          byline: "1 bag every 4 weeks",
          cats: 1,
          price: 22,
          productType: "single",
          promo: null,
          savings: null,
          shipping: null,
          title: "1 Month Supply"
        };
        var multi = {
          vid: 33558076194952,
          image: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/tv_mm_1cat_150x@2x.jpg?1233",
          byline: "3 bags every 12 weeks",
          cats: 1,
          price: 66,
          productType: "multi",
          promo: "+2 FREE Toys*",
          savings: "$5*",
          shipping: "Free Expedited Shipping",
          title: "3 Month Supply"
        };
        arr.push(single);
        arr.push(multi);
      }
      if (this.cats == 2) {
        var _single = {
          vid: 33558076817544,
          image: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/tv_single_1cat.jpg?123",
          byline: "2 bags every 4 weeks",
          cats: 2,
          price: 40,
          productType: "single",
          promo: null,
          savings: null,
          shipping: null,
          title: "1 Month Supply"
        };
        var _multi = {
          vid: 33558076817544,
          image: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/tv_mm_1cat_150x@2x.jpg?1233",
          byline: "6 bags every 12 weeks",
          cats: 2,
          price: 120,
          productType: "multi",
          promo: "+2 FREE Toys*",
          savings: "$10*",
          shipping: "Free Expedited Shipping",
          title: "3 Month Supply"
        };
        arr.push(_single);
        arr.push(_multi);
      }
      if (this.cats == 3) {
        var _single2 = {
          vid: 31455496929416,
          image: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/tv_single_1cat.jpg?123",
          byline: "3 bags every 4 weeks",
          cats: 3,
          price: 60,
          productType: "single",
          promo: null,
          savings: null,
          shipping: null,
          title: "1 Month Supply"
        };
        var _multi2 = {
          vid: 33558068756616,
          image: "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/tv_mm_1cat_150x@2x.jpg?1233",
          byline: "9 bags every 12 weeks",
          cats: 3,
          price: 180,
          productType: "multi",
          promo: "+2 FREE Toys*",
          savings: "$15*",
          shipping: "Free Expedited Shipping",
          title: "3 Month Supply"
        };
        arr.push(_single2);
        arr.push(_multi2);
      }
      return arr;
    },
    cart: function cart() {
      var self = this;
      var cart = {};
      cart.quantity = 1;
      cart.id = getVid();
      cart.properties = {
        shipping_interval_frequency: self.orderType == "single" ? 4 : 12,
        shipping_interval_unit_type: "Weeks",
        subscription_id: 225784
      };
      function getVid() {
        if (self.cats == 1) {
          if (self.orderType == "single") {
            return 9105042604068;
          }
          if (self.orderType == "multi") {
            return 33558076194952;
          }
        }
        if (self.cats == 2) {
          if (self.orderType == "single") {
            return 2054459523087;
          }
          if (self.orderType == "multi") {
            return 33558076817544;
          }
        }
        if (self.cats == 3) {
          if (self.orderType == "single") {
            return 31455496929416;
          }
          if (self.orderType == "multi") {
            return 33558068756616;
          }
        }
      }
      if (self.upsell_taken == true) {
        // cart.properties.bundle = "true";
        // cart.properties.bundle_discount = 0;
      }
      return cart;
    },
    discount: function discount() {
      var discount = null;
      if (this.cats == 1 && this.orderType == "multi") {
        discount = "MULTI5";
      }
      if (this.cats == 2 && this.orderType == "multi") {
        discount = "MULTI10";
      }
      if (this.cats == 3 && this.orderType == "multi") {
        discount = "MULTI15";
      }
      return discount;
    }
  },
  methods: {
    setModal: function setModal(modal) {
      this.modal = modal;
    },
    changeOrderType: function changeOrderType(type) {
      if (type == "single") {
        this.toy = null;
        this.missingToy = false;
      }
    },
    multicat: function multicat() {
      window.location.href = "/pages/multi-cat";
    },
    addItemsToCart: function addItemsToCart() {
      var self = this;
      // console.log("Adding items to cart.");
      // console.log(`Upsell taken: ${self.upsell_taken}`);
      if (self.test == true) {
        if (self.toy !== null) {
          addToy();
        } else {
          if (self.package == "bundle") {
            addBowl();
          } else {
            addCart();
          }
        }
      } else {
        if (self.upsell_taken == true) {
          addFood();
        } else {
          addCart();
        }
      }
      function addToy() {
        var toy = {
          id: self.toy,
          quantity: 1
        };
        axios.post("/cart/add.js", toy).then(function (response) {
          console.log("Toy added to cart..");
          if (self.package == "bundle") {
            addBowl();
          } else {
            addCart();
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
      function addBowl() {
        var toy = {
          id: 34430606737544,
          quantity: 1
        };
        axios.post("/cart/add.js", toy).then(function (response) {
          console.log("Bowl added to cart..");
          addBox();
        }).catch(function (error) {
          console.log(error);
        });
      }
      function addBox() {
        var toy = {
          id: 34430609981576,
          quantity: 1
        };
        axios.post("/cart/add.js", toy).then(function (response) {
          console.log("Box added to cart..");
          addFood();
        }).catch(function (error) {
          console.log(error);
        });
      }
      function addFood() {
        var food = {};
        if (self.orderType == "multi") {
          food = {
            id: 14177898758205,
            quantity: 1,
            properties: {
              shipping_interval_frequency: 4,
              shipping_interval_unit_type: "Weeks",
              subscription_id: 171263,
              recurring_price: 25.0
              //   bundle: "true",
              //   bundle_discount: 0
            }
          };
        } else {
          food = {
            id: 14177898758205,
            quantity: 1,
            properties: {
              shipping_interval_frequency: 4,
              shipping_interval_unit_type: "Weeks",
              subscription_id: 171263,
              recurring_price: 25.0
              //   bundle: "true",
              //   bundle_discount: 0
            }
          };
        }
        axios.post("/cart/add.js", food).then(function (response) {
          console.log("Food added to cart..");
          addCart();
        }).catch(function (error) {
          console.log(error);
        });
      }
      function addCart() {
        axios.post("/cart/add.js", self.cart).then(function (response) {
          console.log("Litter added to cart.");
          self.postEvents();
          self.goToCheckout();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    changeStep: function changeStep(step, obj) {
      console.log("changing step...");
      if (step == 2 && this.step == 1) {
        // gtag("event", "continue_step_2", { event_category: "get_started" });
        ga("send", {
          hitType: "event",
          eventCategory: "get_started",
          eventAction: "continue_step_2"
        });
        console.log("1 -> 2");
      }
      if (step == 3 && this.step == 2) {
        // gtag("event", "continue_step_3", {
        //   event_category: "get_started",
        //   event_label: window.vm.cats + " Cats - " + window.vm.orderType,
        // });
        ga("send", {
          hitType: "event",
          eventCategory: "get_started",
          eventAction: "continue_step_3",
          eventLabel: this.cats + " Cats - " + this.orderType
        });
        console.log("2 -> 3");
        if (this.country == "US") {
          this.step = 3;
          window.location.hash = this.step;
          this.scrollTop();
        } else {
          this.startCheckout(obj);
        }
      } else {
        this.step = step;
        window.location.hash = this.step;
        this.scrollTop();
        if (step == 1 || step == 2) {
          setTimeout(function () {
            Shopify.theme.jsFAQ.init();
            console.log("FAQ");
          }, 1500);
        }
      }
    },
    clearCart: function clearCart() {
      var self = this;
      axios.post("/cart/clear.js").then(function (response) {
        console.log("Cart cleared.");
        self.addItemsToCart();
      }).catch(function (error) {
        console.log(error);
      });
    },
    goToCheckout: function goToCheckout() {
      var self = this;
      var token = undefined;
      function get_cookie(name) {
        return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
      }
      do {
        token = get_cookie("cart");
      } while (token == undefined);

      var myshopify_domain = "pretty-litter.myshopify.com";
      var ga_linker = "";
      try {
        ga_linker = ga.getAll()[0].get("linkerParam");
      } catch (err) {
        ga_linker = "";
      }
      var customer_param = "";
      if (getCookie("stc114954") !== undefined) {
        console.log("Rakuten - do something");
        document.cookie = "stc114954=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.prettylitter.com; path=/;";
        document.cookie = "stc114954=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=prettylitter.com; path=/;";
      } else {
        console.log("Rakuten - do nothing");
      }
      if (getCookie("_landing_page") !== undefined) {
        console.log("_landing_page - do something");
        document.cookie = "_landing_page=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.prettylitter.com; path=/;";
        document.cookie = "_landing_page=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=prettylitter.com; path=/;";
      } else {
        console.log("_landing_page - do nothing");
      }
      if (self.discount !== null) {
        var checkout_url = "https://checkout.prettylitter.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker + "&discount=" + self.discount + "&" + customer_param;
        console.log(checkout_url);
        window.location.href = checkout_url;
      } else {
        var _checkout_url = "https://checkout.prettylitter.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker + "&" + customer_param;
        console.log(_checkout_url);
        window.location.href = _checkout_url;
      }
    },
    initializeSwiper: function initializeSwiper() {
      console.log("initializeSwiper.");
      setTimeout(function () {
        var mySwiper = new Swiper(".swiper-container", {
          direction: "horizontal",
          loop: false,
          slidesPerView: 3,
          autoHeight: true,
          noSwiping: true,
          noSwipingClass: "swiper-slide",
          spaceBetween: 20,
          breakpoints: {
            // when window width is <= 767px
            767: {
              noSwiping: false,
              slidesPerView: 1.25,
              spaceBetween: 10
            }
          },
          centeredSlides: true,
          initialSlide: 1
        });
      }, 650);
    },
    postEvents: function postEvents() {
      //pinterest
      if (typeof pintrk !== "undefined") {
        console.log("pintrk defined");
        pintrk("track", "addtocart", {
          value: 100,
          order_quantity: 1,
          currency: "USD"
        });
      }
    },
    scrollTop: function scrollTop() {
      $("html, body").animate({
        scrollTop: $("body").offset().top
      }, 500);
    },
    newCheckout: function newCheckout(obj) {
      if (this.toy == null && this.orderType == "multi") {
        this.missingToy = true;
      } else {
        this.test = true;
        console.log("startCheckout");
        if (!this.processing) {
          this.processing = true;
          if (this.upsell_taken == true && this.country == "US") {
            // gtag("event", "proceed_to_checkout", {
            //   event_category: "get_started",
            //   event_label: "add food",
            // });
            ga("send", {
              hitType: "event",
              eventCategory: "get_started",
              eventAction: "proceed_to_checkout",
              eventLabel: "add food"
            });
          }
          if (this.upsell_taken == false && this.country == "US") {
            // gtag("event", "proceed_to_checkout", {
            //   event_category: "get_started",
            //   event_label: "no food",
            // });
            ga("send", {
              hitType: "event",
              eventCategory: "get_started",
              eventAction: "proceed_to_checkout",
              eventLabel: "no food"
            });
          }
          if (this.country !== "US") {
            // gtag("event", "proceed_to_checkout", {
            //   event_category: "get_started",
            //   event_label: "food ineligible",
            // });
            ga("send", {
              hitType: "event",
              eventCategory: "get_started",
              eventAction: "proceed_to_checkout",
              eventLabel: "food ineligible"
            });
          }
          this.clearCart();
          if (this.step == 3) {
            if (this.upsell_taken !== false) {
              obj.target.innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
            } else {
              obj.target.innerHTML = "Checking out... <i class='fas fa-spin fa-spinner'></i>";
            }
          } else {
            if (this.upsell_taken == true || this.step == 1) {
              obj.target.innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
            }
            if (this.upsell_taken == false || this.step == 2) {
              obj.target.innerHTML = "Checking out... <i class='fas fa-spin fa-spinner'></i>";
            }
          }
        }
      }
    },
    startCheckout: function startCheckout(obj) {
      console.log("startCheckout");
      if (!this.processing) {
        this.processing = true;
        if (this.upsell_taken == true && this.country == "US") {
          // gtag("event", "proceed_to_checkout", {
          //   event_category: "get_started",
          //   event_label: "add food",
          // });
          ga("send", {
            hitType: "event",
            eventCategory: "get_started",
            eventAction: "proceed_to_checkout",
            eventLabel: "add food"
          });
        }
        if (this.upsell_taken == false && this.country == "US") {
          // gtag("event", "proceed_to_checkout", {
          //   event_category: "get_started",
          //   event_label: "no food",
          // });
          ga("send", {
            hitType: "event",
            eventCategory: "get_started",
            eventAction: "proceed_to_checkout",
            eventLabel: "no food"
          });
        }
        if (this.country !== "US") {
          // gtag("event", "proceed_to_checkout", {
          //   event_category: "get_started",
          //   event_label: "food ineligible",
          // });
          ga("send", {
            hitType: "event",
            eventCategory: "get_started",
            eventAction: "proceed_to_checkout",
            eventLabel: "food ineligible"
          });
        }
        this.clearCart();
        if (this.step == 3) {
          if (this.upsell_taken !== false) {
            obj.target.innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
          } else {
            obj.target.innerHTML = "Checking out... <i class='fas fa-spin fa-spinner'></i>";
          }
        } else {
          if (this.upsell_taken == true || this.step == 1) {
            obj.target.innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
          }
          if (this.upsell_taken == false || this.step == 2) {
            obj.target.innerHTML = "Checking out... <i class='fas fa-spin fa-spinner'></i>";
          }
        }
      }
    },
    stepTwo: function stepTwo(obj) {
      var self = this;
      if (obj.target.id == "checkoutStep1") {
        document.getElementById(obj.target.id).innerHTML = "Adding... <i class='fas fa-spin fa-spinner'></i>";
      }
      setTimeout(function () {
        if (self.toyUpsell == true && self.country == "US") {
          self.step = 2;
          window.scrollTo({ top: 0, behavior: "smooth" });
          self.initializeSwiper();
        } else {
          self.startCheckout;
        }
      }, 1500);
    },
    togglePopup: function togglePopup() {
      this.pricePopup = !this.pricePopup;
    }
  },
  filters: {
    getIcon: function getIcon(n) {
      var baseUrl = "https://cdn.shopify.com/s/files/1/0997/4496/t/22/assets/";
      if (n == 1) {
        return baseUrl + "icon_v2_1cat@2x.png";
      }
      if (n == 2) {
        return baseUrl + "icon_v2_2cats@2x.png";
      }
      if (n == 3) {
        return baseUrl + "icon_v2_3cats@2x.png";
      }
    },
    getDiscount: function getDiscount(n) {
      if (n == 1) {
        return "$22";
      }
      if (n == 2) {
        return "$44";
      }
      if (n == 3) {
        return "$66";
      }
    },
    getPrice: function getPrice(n) {
      if (n == 1) {
        return "$22";
      }
      if (n == 2) {
        return "$40";
      }
      if (n == 3) {
        return "$60";
      }
    }
  }
});

//nonvue items

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}
function setCookie(name, value, expiration) {
  document.cookie = name + "=" + value + "; domain=prettylitter.com; path=/; expires=" + expiration + ";";
}
var bfcm_cookie = getCookie("bfcm");
if (bfcm_cookie == undefined) {
  setCookie("bfcm19", "onebag", "Wed Dec 04 2019 00:00:00 GMT-0800");
}

function HashHandler() {
  if (window.vm.loaded) {
    if (window.location.hash !== "" && window.location.hash !== "#") {
      // console.log("The Hash has changed!");
      var hash = window.location.hash.split("#")[1];
      // console.log(hash, window.vm.step);
      if (hash == 2 && window.vm.step == 1) {
        // gtag("event", "continue_step_2", { event_category: "get_started" });
        // console.log("1 -> 2");
        window.vm.changeStep(hash);
      }
      if (hash == 3 && window.vm.step == 2) {
        // gtag("event", "continue_step_3", { event_category: "get_started" });
        // console.log("2 -> 3");
        window.vm.changeStep(hash);
      }
      if (hash == 1 && window.vm.step == 2) {
        // gtag("event", "back_to_step_1", { event_category: "get_started" });
        ga("send", {
          hitType: "event",
          eventCategory: "get_started",
          eventAction: "back_to_step_1"
        });
        console.log("2 -> 1");
        window.vm.changeStep(hash);
      }
      if (hash == 2 && window.vm.step == 3) {
        // gtag("event", "back_to_step_2", { event_category: "get_started" });
        ga("send", {
          hitType: "event",
          eventCategory: "get_started",
          eventAction: "back_to_step_2"
        });
        console.log("3 -> 2");
        window.vm.changeStep(hash);
      }
    }
  }
}

window.addEventListener("hashchange", HashHandler, false);
window.addEventListener("DOMContentLoaded", function (event) {
  console.log("DOM fully loaded and parsed");
  Shopify.theme.jsFAQ.init();
});